export const defaultTableCells = [
  {
    label: 'Requested by',
    display: true,
    width: 120
  },
  {
    label: 'Email',
    display: false,
    width: 160
  },
  {
    label: 'Created Date',
    display: true,
    width: 100
  },
  {
    label: 'Title',
    display: true,
    width: 100
  },
  {
    label: 'Discount Type',
    display: false,
    width: 100
  },
  {
    label: 'Start Date',
    display: false,
    width: 100
  },
  {
    label: 'End Date',
    display: false,
    width: 100
  },
  {
    label: 'Details',
    display: true,
    width: 80
  },
];
